angular
    .module('empower.control')
    .directive("localityInput", ['$rootScope', 'commonService', 'popupService',
        function ($rootScope, commonService, popupService) {
            return {
                restrict: 'E',
                templateUrl: 'module/control/localitySearch/locality-input.html',
                scope: {
                    formObject: '=',
                    suburbInputName: '=',
                    suburbModel: '=',
                    stateInputName: '=',
                    stateModel: '=',
                    postcodeInputName: '=',
                    postcodeModel: '=',
                    isRequired: '=',
                    isReadonly: '='
                },
                controller: function ($scope) {
                    $scope.localityId = commonService.generateRandomId();

                    $scope.openLocalitySearch = function() {
                        if (!$scope.isReadonly) {
                            popupService.showLocalitySearchPopup({ eventEmit: $scope.localityId, emitOnClose: true });
                        }                
                    }
        
                    $scope.$on($scope.localityId, function (event, locality) {
                        $scope.selectLocality(locality);
                    });
        
                    $scope.selectLocality = function(locality) {
                        if (locality) {
                            $scope.suburbModel = locality.Suburb;
                            $scope.stateModel = locality.State;
                            $scope.postcodeModel = locality.PostCode;
            
                            $scope.formObject[$scope.suburbInputName].$setDirty();
                            $scope.formObject[$scope.stateInputName].$setDirty();
                            $scope.formObject[$scope.postcodeInputName].$setDirty();
                        } else {
                            $scope.formObject[$scope.suburbInputName].$setTouched();
                            $scope.formObject[$scope.stateInputName].$setTouched();
                            $scope.formObject[$scope.postcodeInputName].$setTouched();
                        }
                    }
                    
                }, // controller
                link: function (scope, element, attrs) {
                } // link
            };
        }
    ])
